/* eslint-disable */  // Disabled eslint as this is not compiled by webpack/babel

/*
  This file 'settings.js' is not compiled by Webpack but is included in the webpack output. TODO: Actually I think it is compiled in and then also included separately?

  When the Nginx container starts up, the containers 'runtime.sh' script (frontend/docker/nginx/runtime.sh) runs and replaces some of the values below. This
  allows us to dynamically set the app variable values based on the environment variables we pass to the container at runtime.
*/
const settings = (function () {
  const pathJoin = function (pathList) {
    let joinedPath = pathList
      .map((path) => {
        // Remove beginning and trailing "/" from each path
        // and join all paths together with a "/".
        if (path[0] === '/') {
          path = path.slice(1);
        }
        if (path[path.length - 1] === '/') {
          path = path.slice(0, path.length - 1);
        }
        return path;
      })
      .join('/');

    // Add a "/" to the end of the joined path
    if (joinedPath.charAt(joinedPath.length - 1) != '/') {
      joinedPath += '/';
    }
    return joinedPath;
  };

  // ENVIRON VARIABLES
  const APP_NAME = process.env.APP_NAME; // CREWROSTERING
  const APP_ENV = process.env.APP_ENV; // LOCAL, DEV, TEST, QA, PROD
  const SHAREPOINT_BASE_ADDRESS = process.env.SHAREPOINT_BASE_ADDRESS; // "https://spo.bhpbilliton.com/sites/crewrostering/Shared%20Documents/"

  // ci values
  const APP_VER = process.env.APP_VER;  // The version which was tagged in git that kicked off the deployment.
  const CI_DEPLOY_NUMBER = process.env.CI_DEPLOY_NUMBER;  // The CI build pipeline number.
  const CI_DEPLOY_DATETIME = process.env.CI_DEPLOY_DATETIME;
  const GIT_COMMIT = process.env.GIT_COMMIT;  // SHort Git Commit hash.

  // backend uri
  const APP_API_URI = process.env.APP_API_URI; // "https://crewrostering-dev.bhp.com/v1"
  const REPORTS_URL = process.env.REPORTS_URL; // https://reports-dev.badevhub.com/

  // AD
  const AZURE_AD_INSTANCE = process.env.AZURE_AD_INSTANCE;
  const AZURE_AD_TENANT = process.env.AZURE_AD_TENANT;
  const AZURE_AD_CLIENT_ID = process.env.AZURE_AD_CLIENT_ID;

  // Sentry DSN
  const SENTRY_DSN = process.env.SENTRY_DSN;

  // New Relic
  const NEW_RELIC_BROWSER_LICENSE_KEY = process.env.NEW_RELIC_BROWSER_LICENSE_KEY;
  const NEW_RELIC_BROWSER_APPLICATION_ID = process.env.NEW_RELIC_BROWSER_APPLICATION_ID;
  const NEW_RELIC_BROWSER_ACCOUNT_ID = process.env.NEW_RELIC_BROWSER_ACCOUNT_ID;
  const NEW_RELIC_BROWSER_TRUST_KEY = process.env.NEW_RELIC_BROWSER_TRUST_KEY;
  const NEW_RELIC_BROWSER_BEACON = process.env.NEW_RELIC_BROWSER_BEACON;

  console.log(`App Name: ${APP_NAME}`);
  console.log(`App Env: ${APP_ENV}`);
  console.log(`App Version: ${APP_VER}`);
  console.log(`App Version Commit: ${GIT_COMMIT}`);
  console.log(`App Deployed Date/Time (UTC): ${CI_DEPLOY_DATETIME}`);

  const baseUri = function () {
    return '/';  // Previously this operated under a subpath, now it is in the root. ie. http://crewrostering.bhp.com/
  };
  const baseUrl = function () {
    return pathJoin([document.location.origin, baseUri()]);
  };
  const previousUri = function () {
    return '/roster/';  // V1 path
  };
  const previousUrl = function () {
    return pathJoin([document.location.origin, previousUri()]);
  };
  const baseApiDomain = function () {
    return (APP_API_URI + "/")
  };
  const loginUrl = function () {
    return '/login/';
  };
  const siteTenancyUrl = function () {
    return '/tenancy/';
  };
  const dashboardUrl = function () {
    return '/home/roster/';
  };
  const msalLoginUrl = function () {
    return pathJoin([baseUrl(), loginUrl()]);
  };
  const msalEndpoints = {};
  msalEndpoints[baseApiDomain()] = 'https://graph.windows.net';

  const settings = {
    BASE_URI() {
      return baseUri();
    },
    BASE_URL() {
      return baseUrl();
    },
    PREVIOUS_URI() {
      return previousUri();
    },
    PREVIOUS_URL() {
      return previousUrl();
    },
    BASE_API_DOMAIN() {
      return baseApiDomain();
    },
    LOGIN_URL() {
      return loginUrl();
    },
    DASHBOARD_URL() {
      return dashboardUrl();
    },
    SITE_TENANCY_URL() {
      return siteTenancyUrl();
    },
    TIMEZONE_BLACKLIST: ['US/Pacific-New'],
    SW_UPDATE_INTERVAL_MS: 1000 * 60 * 10, // Check every 10min for update
    NOTIFICATIONS_UPDATE_INTERVAL_MS: 1000 * 60 * 2, // Check every 2min for update
    REPORTS_URL: REPORTS_URL,
    SHAREPOINT_BASE_ADDRESS() {
      return SHAREPOINT_BASE_ADDRESS;
    },

    APP_CONFIG: {
      appName: APP_NAME,
      environment: APP_ENV,
      versionNo: `${APP_VER}-${CI_DEPLOY_NUMBER}`,
      versionSemantic: APP_VER,
      buildNumber: CI_DEPLOY_NUMBER,
      sentryDsn: SENTRY_DSN,
      sentryVersion: GIT_COMMIT,
      dropListSize: 500,
      defaultTablePage: 1,
      defaultTablePageSize: 50,
      defaultTablePageSmallSize: 5,
      defaultTableFilterActiveColor: '#FF3D00',
      defaultTableFilterInactiveColor: '#555',
      defaultTimelineActivityCreateCount: 1,
      defaultTimelineActivityHoursBetween: 24,
      defaultTimelineMaxDays: 30,
      defaultTimelineSnapMinutes: 15,
      slidePanelVerticalMinSize: 200,
      slidePanelVerticalMaxSize: -200,
      slidePanelHorizontalMinSize: 40,
      slidePanelHorizontalMaxSize: -40,
      minActivityDurationMinutes: 15,
      defaultTravelActivityColor: '#ffff0c', // Yellow - cause yellow is the color of travel
      defaultRouteType: 'Intrastate',
      availabilityOpacity: '0.3',
      new_relic_browser_license_key: NEW_RELIC_BROWSER_LICENSE_KEY,
      new_relic_browser_application_id: NEW_RELIC_BROWSER_APPLICATION_ID,
      new_relic_browser_account_id: NEW_RELIC_BROWSER_ACCOUNT_ID,
      new_relic_browser_trust_key: NEW_RELIC_BROWSER_TRUST_KEY,
      new_relic_browser_beacon: NEW_RELIC_BROWSER_BEACON
    },

    AUTH_CONFIG: {
      cacheLocation: 'sessionStorage' // Where to store the selected login option (localStorage/sessionStorage/cookieStorage)
    },

    JWT_CONFIG: {
      refreshThreshold: 10, // Token refresh threshold in minutes
      cacheLocation: 'sessionStorage' // Where to storage the token details (localStorage/sessionStorage/cookieStorage)
    },

    MSAL_CONFIG: {
      instance: AZURE_AD_INSTANCE, // Refer to libs/adal/adal.js for configuration parameters
      tenant: AZURE_AD_TENANT, // Default tenant id refers to the azure portal
      clientId: AZURE_AD_CLIENT_ID, // Default client id refers to the Application ID for the application within azure portal
      redirectUri: msalLoginUrl(), // Page which receives and processes the token from azure
      postLogoutRedirectUri: msalLoginUrl(), // Page to redirect post logout from azure.
      cacheLocation: 'sessionStorage', // enable localStorage for IE, as sessionStorage does not work for localhost. (localStorage/sessionStorage)
      navigateToLoginRequestUrl: false,
      endpoints: msalEndpoints
    },

    COOKIE_STORAGE: {
      secure: false,
      path: '/',
      prefix: 'BHP_CR_'
    }
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = settings;
  }

  return settings;
}());
